class ValidationSummary {
	constructor($timeout, $rootScope, CommonService, $templateCache) {
		this.scope = {
			for: '='
		};
		this.restrict = 'E';
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.link = this.ValidationLink;
		this.CommonService = CommonService;
	}

	ValidationLink(scope, element, attrs) {
		const formName = attrs.for;
		const $element = angular.element(element);
		const $form = angular.element(`form[name=${formName}]`);

		this.$timeout(() => {
			this._toggleValidationDisplay(scope, $element, formName);

			this._registerEventsHandler($form, scope, $element, formName);
			this.$rootScope.$on('clearance-selected-entity-type-changed', () => {
				this._registerEventsHandler($form, scope, $element, formName);
			});
		});
	}

	_registerEventsHandler($form, scope, $element, formName) {
		angular.element(`input, select`, $form).each((i, input) => {
			angular.element(input).on('change input', (event) => {
				const fieldName = angular.element(event.target).attr('name');
				console.log(`Checking for: ${fieldName}`);
				this._toggleValidationDisplay(scope, $element, formName);
			});
		});
	}

	_toggleValidationDisplay(scope, $element, formName) {
		if (!scope.$parent[formName]) {
			return;
		}

		let isDirty = scope.$parent[formName].$dirty;
		let hasErrors = !!scope.$parent[formName].$error && Object.keys(scope.$parent[formName].$error).length > 0;

		this.$timeout(() => {
			if (isDirty && hasErrors) {
				this.showErrors(scope, $element, formName);
			} else {
				$element.empty();
			}
		});
	}

	showErrors(scope, $element, formName) {
		const form = scope.$parent[formName];
		const errors = form.$error;

		let html = `
				<label class="header">
					The following errors are preventing completion:
				</label>
			`;

		Object.keys(errors).forEach((key) => {
			errors[key].forEach((error) => {
				let fieldLabelText;
				const fieldName = error.$name;
				const $form = angular.element(`form[name=${formName}]`);
				const $field = angular.element(`[name=${fieldName}]`, $form);
				const $parent = $field.parent().parent();

				let label;
				const isDatePicker = angular.element('.date-picker', $parent).length > 0;
				if (isDatePicker) {
					const $label = angular.element(`label[for=${fieldName}]`, $parent.parent());
					if ($label) {
						label = $label;
					}
				} else {
					label = angular.element(`label[for=${fieldName}]`, $parent);
				}

				const span = angular.element('span.clearance-label', $field.parent().parent());

				if (label && label.length > 0) {
					if (label.text() && label.text().length > 0) {
						fieldLabelText = this.CommonService.cleanUpStrings(label.text());
					}
				} else if (span && span.length > 0) {
					if (span.text() && span.text().length > 0) {
						fieldLabelText = this.CommonService.cleanUpStrings(span.text());
					}
				}

				if (!fieldLabelText) {
					const text = $field.attr('placeholder');
					fieldLabelText = text;
				}

				html = this._generateHtml(fieldName, form, key, html, fieldLabelText);
			});

			html += '</ul>';
		});

		$element.html(html);
	}

	_generateHtml(fieldName, form, key, html, fieldLabelText) {
		if (!fieldLabelText) {
			return html;
		}

		const formName = form.$name;
		const $form = angular.element(`form[name=${formName}]`);
		const $container = angular.element(`[name="${fieldName}"]`, $form).closest('[ng-if]');
		const isShown = $container.css('display') !== 'none';
		if (form[fieldName].$error[key] && isShown) {
			html += `
				<label><strong>${fieldLabelText.trim()}</strong><span> - 
			`;
			const error = angular.element(`validation[for=${fieldName}] error[type=${key}]`, $form);
			if (error && error.length > 0) {
				html += `<em>${error.text()}</em></span></label>`;
			} else {
				throw `Validation Summary - There is no related error for field: ${fieldName} type: ${key}`;
			}
		}
		return html;
	}
}

export default /* @ngInject */ ($timeout, $rootScope, CommonService, $templateCache) =>
	new ValidationSummary($timeout, $rootScope, CommonService, $templateCache);
